import { type PropsWithChildren, type ReactNode } from 'react';
import { CircleHelp } from 'lucide-react';

import { Tooltip } from '@/components/ui/tooltip';

export type TooltipProps = {
  content: ReactNode;
  delay?: boolean | number;
};
export function TooltipAdditionalInfo({
  children,
  content,
}: PropsWithChildren<TooltipProps>) {
  return (
    <div className="mb-2 flex items-center gap-2">
      {children}
      <Tooltip content={content}>
        <CircleHelp className="size-4 text-gray-400" />
      </Tooltip>
    </div>
  );
}
